enum UpgradePlanFieldNames {
  ContactEmail = 'contactEmail',
  Features = 'features',
  DesiredUserLimit = 'desiredUserLimit',
  Message = 'message',
}

export default UpgradePlanFieldNames;
